import moment from 'moment';
import { ODataIsAliveResponse } from '../../interfaces/is-alive-set.interface';

/**
 * Converts a `moment.Moment` to its serializable state representation. An invalid moment (the
 * "not set" sentinel used throughout the legacy service) becomes the empty string, never `null`.
 *
 * @param value the moment to convert
 * @returns the ISO string, or `''` when `value` is invalid
 */
export function momentToTimestampState(value: moment.Moment): string {
    return value.isValid() ? value.toISOString() : '';
}

/**
 * Converts a timestamp state string back to a `moment.Moment`. The empty string — the "not set"
 * sentinel — becomes `moment.invalid()`, mirroring `momentToTimestampState`.
 *
 * @param value the state string to convert
 * @returns the moment, or an invalid moment when `value` is `''`
 */
export function timestampStateToMoment(value: string): moment.Moment {
    return value === '' ? moment.invalid() : moment.utc(value);
}

/**
 * Extracts the external gateway timestamp from an `IsaliveSet` response, keeping the OData
 * response shape out of the effect that fetches it. Ported from the legacy
 * `moment.utc(response.d.results[0].TimeStamp, 'YYYYMMDDHHmmss')`.
 *
 * @param response the `IsaliveSet` OData response
 * @returns the external timestamp as an ISO string
 */
export function isAliveResponseToTimestampState(response: ODataIsAliveResponse): string {
    return moment.utc(response.d.results[0].TimeStamp, 'YYYYMMDDHHmmss').toISOString();
}
